<template lang="html">
  <button
    class="hidden-button addParam"
    style="background-color:white;">
    <i :class="[buttonClasses[this.styleType]]"></i>
    <slot></slot>
  </button>
</template>

<script>
export default {
  data () {
    return {
      buttonClass: 'btn',
      buttonClasses: {
        plus: 'fas fa-plus'
      }
    }
  },
  props: {
    styleType: { type: String, default: 'plus' }
  }
}
</script>

<style lang="scss" scoped>
.addParam {
  align-self: center;
  border: 1px solid $mainColor;
  height: 30px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  width: 30px;
  cursor: pointer;
}
</style>
